<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="night_mode"
        small
        icon
        color="secondary"
        dark
        v-bind="attrs"
        v-on="on"
        @click.stop="night_mode = !night_mode"
      >
        <v-icon>mdi-brightness-7</v-icon>
      </v-btn>
      <v-btn
        v-else
        small
        icon
        color="secondary"
        dark
        v-bind="attrs"
        v-on="on"
        @click.stop="night_mode = !night_mode"
      >
        <v-icon>mdi-brightness-3</v-icon>
      </v-btn>
    </template>
    <span>Switch dark/light mode in this browser</span>
  </v-tooltip>
</template>
<script>
export default {
  name: "LigthModes",
  props: {
    persist_config: {
      type: Boolean,
      default: false,
    },
    default_night_mode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { night_mode: false };
  },
  methods: {
    switch_mode(night_mode) {
      this.$vuetify.theme.dark = night_mode;
      if (this.persist_config)
        try {
          localStorage.setItem(
            "night_mode",
            JSON.stringify({ night_mode: night_mode })
          );
        } catch (error) {
          console.log(error);
        }
    },
    load_from_storage() {
      const night_mode = localStorage.getItem("night_mode");
      if (this.persist_config && night_mode) {
        try {
          let data = JSON.parse(night_mode);
          this.night_mode = data.night_mode;
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  watch: {
    night_mode(nval) {
      this.switch_mode(nval);
    },
  },
  mounted() {
    this.night_mode = this.default_night_mode;
    this.load_from_storage();
    this.switch_mode(this.night_mode);
  },
};
</script>
